// extracted by mini-css-extract-plugin
export var checkIcon = "_b-2";
export var heading = "_b-1";
export var panel = "_b-0";